import { render, staticRenderFns } from "./SendOtchet.vue?vue&type=template&id=09dceb7e"
import script from "./SendOtchet.vue?vue&type=script&lang=js"
export * from "./SendOtchet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports